module.exports = __webpack_public_path__ + "img/test.45376f8c.png";